export class User {
	public static parse(data: IUser): User {
		const user: User = new User();
		if (data.id !== undefined) {
			user.id = data.id;
		}
		if (data.displayName !== undefined) {
			user.displayName = data.displayName;
		}
		if (data.userType !== undefined) {
			user.userType = data.userType;
		}
		return user;
	}
	public id: string = "";
	public displayName: string = "";
	public userType: string = "";
}

export interface IUser {
	id?: string;
	displayName?: string;
	userType?: string;
}
